/* =====================================================================
 * bc-customizer-relay.js — the diamond-customizer journey → Ledger
 *
 * Split out of snippets/bc-customizer-journey.liquid on 2026-09-05 (perf item
 * 27). Identical behaviour, two differences:
 *   1. it is an `asset_url` file, so it is cached across navigations instead
 *      of re-parsed as inline HTML on every page;
 *   2. it is rendered on PRODUCT templates only — window.DiamondCustomizer
 *      exists nowhere else, so on a homepage/blog/collection/cart view this
 *      code could never fire and only ever cost bytes.
 *
 * It registers a handler with BcRelay (assets/bc-relay-shared.js), which owns
 * the single dataLayer.push wrap, the /collect envelope and the transport.
 * Load order: bc-relay-shared.js first, both `defer`, both at the end of
 * <body> — the same position and ordering the inline block had.
 *
 * Mirrors the customizer's EXISTING GA4/Klaviyo dataLayer stream: every
 * customizer_* action (customizer_view, _carat_select, _metal_select,
 * _shape_select, _color_select, _clarity_select, _purity_select,
 * _quality_select …) plus the terminal customized_diamond, with bc_aid +
 * session_id + product handle + the selection value + the current calculated
 * price. De-dupe is deliberately NOT applied — every step is a distinct
 * journey event; only the shared 300 ms identical-consecutive debounce
 * collapses slider-drag spam.
 * ===================================================================== */
(function () {
  'use strict';

  if (!window.BcRelay || typeof window.BcRelay.on !== 'function') return;

  // Selection keys the customizer's trackEngagement() calls attach to the push.
  var SELECTION_KEYS = ['carat', 'purity', 'color', 'clarity', 'shape', 'metal', 'method', 'product_handle'];

  // Current calculated price (cents) straight from the live customizer state.
  // committedPrice is the last computed total; null before the first price calc.
  function currentPriceCents() {
    try {
      var s = window.DiamondCustomizer && window.DiamondCustomizer.state;
      var v = s ? s.committedPrice : null;
      return (typeof v === 'number' && isFinite(v)) ? v : null;
    } catch (e) { return null; }
  }

  // Pull the selection value(s) out of the pushed dataLayer object.
  function extractSelection(ev) {
    var out = {};
    for (var i = 0; i < SELECTION_KEYS.length; i++) {
      var k = SELECTION_KEYS[i];
      if (ev[k] !== undefined && ev[k] !== null && ev[k] !== '') out[k] = ev[k];
    }
    return out;
  }

  // The customizer's selected MOUNTING variant: the bare numeric Shopify
  // variant id, i.e. the Meta catalog id (the same id its view_item
  // item_variant_id uses). Digits only, else null — a SKU or handle is never a
  // catalog id. Lets bc-tracking send content_ids/contents on CustomizeProduct.
  function selectedVariantId() {
    try {
      var s = window.DiamondCustomizer && window.DiamondCustomizer.state;
      var v = s ? String(s.selectedVariantId == null ? '' : s.selectedVariantId) : '';
      return /^\d{5,20}$/.test(v) ? v : null;
    } catch (e) { return null; }
  }

  function activeCurrency() {
    // committedPrice is in the shopper's active PRESENTMENT currency, not
    // shop-base USD. Name it, so the server can send value+currency to Meta
    // instead of refusing to invent money (2026-09-03 audit).
    try {
      var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      return (typeof cur === 'string' && /^[A-Z]{3}$/.test(cur)) ? cur : null;
    } catch (e) { return null; }
  }

  window.BcRelay.on({
    match: function (name) {
      return name.indexOf('customizer_') === 0 || name === 'customized_diamond';
    },
    build: function (ev) {
      var name = ev.event;
      var isTerminal = (name === 'customized_diamond');
      var selection = isTerminal ? {} : extractSelection(ev);
      var priceCents = currentPriceCents();
      var payload = window.BcRelay.basePayload(name);
      payload.customizer_step = ev.customizer_step || null;
      payload.customizer_session_id = ev.customizer_session_id || null;
      payload.selection = selection;
      // Terminal event carries the full config + price the customizer computed.
      payload.config = isTerminal ? (ev.customized_diamond || null) : null;
      payload.price_cents = priceCents;
      payload.currency = activeCurrency();
      payload.variant_id = selectedVariantId();
      return {
        name: name,
        payload: payload,
        // Top-level event_id (2026-09-03): the door keys the signal on it (so
        // two identical customizations are two signals, not one content-hash)
        // and, when uuid-shaped, forwards it as the Meta dedup id so the funnel
        // lane's CustomizeProduct pairs with the browser/sGTM copies. Only the
        // terminal customized_diamond push mints one; step events keep the old
        // key.
        eventId: ev.event_id,
        key: name + '|' + JSON.stringify(selection) + '|' + priceCents
      };
    }
  });
})();
